import React, { useLayoutEffect } from 'react';
import { useSelector } from 'react-redux'
import auth from '../../../services/auth/AuthProvider';

const CreateAccount = () => {
    const authConfig = useSelector(state => state.config);

    useLayoutEffect(() => {
        if (authConfig) {
            auth.initProvider(authConfig);
            auth.signup();
        }
    }, [])

    return (           
        <div/>
    )
}

export default CreateAccount
